<script setup lang="ts">
import type { IMenuTopBarProps } from './interfaces'

const { menuSection } = defineProps<IMenuTopBarProps>()

const { sendMenuEvent } = useSendEvent()
</script>

<template>
    <div
        class="flex h-[--lp-menu-bar-mobile] w-full items-center border-b bg-plus-lp-dark-blue px-4 text-plus-lp-white md:h-[--lp-menu-bar-desktop] md:px-0"
    >
        <div class="menu-top-bar flex size-full h-full items-center justify-between">
            <div class="flex h-full items-center md:gap-x-6">
                <!-- logo  -->
                <div class="relative z-20 flex items-center gap-6">
                    <a
                        href="/"
                        class="plus-lp-focus-link"
                        @click="sendMenuEvent('logo', '/')"
                    >
                        <img
                            src="https://api.plus.pl/file/images_lp/plus_acse_landingpages/menu/iPlus.svg"
                            alt="plus-logo"
                        />
                    </a>
                </div>

                <!-- desktop navbar -->
                <PlusBlogLpMoleculeMenuDesktop :menu-section="menuSection" />
            </div>

            <!-- kontakt / koszyk / zaloguj itp -->
            <PlusBlogLpMoleculeMenuAside />
        </div>
    </div>
</template>

<style scoped lang="scss">
.menu-top-bar {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-left: 1rem;
    padding-right: 1rem;
    @media (min-width: 768px) {
        max-width: 1224px;
    }
    @media (min-width: 1224px) {
        padding-left: 0;
        padding-right: 0;
    }
}
</style>
